import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Intro from "@/components/Intro";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Capabilities from "@/components/Capabilities";
import About from "@/components/About";
import Process from "@/components/Process";
import WhyChoose from "@/components/WhyChoose";
import CTA from "@/components/CTA";
import Contact from "@/components/Contact";
import TeamAccess from "@/components/TeamAccess";
import Footer from "@/components/Footer";
import "@/App.css";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain bg-ink text-ivory min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <Marquee />
        <Services />
        <Capabilities />
        <About />
        <Process />
        <WhyChoose />
        <CTA />
        <Contact />
        <TeamAccess />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
